import { ListingSellerDraftModel } from '@steelbuy/ts-shared';

import { createEntityDataContext } from '../../util/provider/EntityDataProvider';

export const ListingSellerDraftEntityData = createEntityDataContext<ListingSellerDraftModel>();
